export enum DepositPolicyType {
  DEFAULT_DEPOSIT = 'default',
  ONE_NIGHT_DEPOSIT = 'oneNight',
  FULL_DEPOSIT = 'full'
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/rate/deposit-policy.type.model.ts